import React from 'react'
import { LoadState } from '@ally/use-data-domain'

import WidgetError from '../WidgetError'
import { BadgeFactory } from './BadgeFactory'
import LoadingSpinner from '../LoadingSpinner'
import { useHostCustomer } from '../../../hooks/useHostCustomer'

const WidgetBody: React.FC = (): React.ReactElement => {
  const { hostLoading } = useHostCustomer()

  switch (hostLoading) {
    case LoadState.LOADED:
      return <BadgeFactory />

    case LoadState.FAILED:
      return <WidgetError />

    case LoadState.LOADING:
      return <LoadingSpinner />

    default:
      return <WidgetError />
  }
}

export default WidgetBody
